import { Text } from '@chakra-ui/react'

import VideoTutorialButton from 'src/components/widgets/VideoTutorialButton/VideoTutorialButton'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'
import { capitalize } from 'src/lib/utils'

import { ElementProps } from '../../GenericElement/GenericElement'

const Header: React.FC<ElementProps> = ({ item }) => {
  const { brandColor } = useCurrentUser()

  return (
    <Text as="h5" className="thick" ml={4} data-testid="editItem-title">
      {`Edit ${capitalize(item.type)}`}
      <VideoTutorialButton
        display="inline-flex"
        ml={2}
        brandColor={brandColor}
        vimeoUrl="https://vimeo.com/817480791/ddccf20be8"
        tooltip="Product Pro Tips"
      />
    </Text>
  )
}

export default Header
